<template>
  <div class="Body" :theme="Theme">
    <router-view v-if="isRouterAlive" />
    <a v-show="$route.name!='login'&&$route.name!='register'&&$route.name!='serviceCenter'&&InitData.serviceList.length?true:false" id="Service" href="javascript:;" @click="openService(InitData.serviceList[0].url,InitData.serviceList[0].id,InitData.serviceList[0].urltype)">
      <img v-if="InitData.serviceList.length" :src="InitData.setting.up_url+InitData.serviceList[0].cover_img" width="55">
    </a>
    <!-- <a href="javascript:;" id="Robot" v-show="showRobot" @click="openRobot">
      <img :src="`./static/icon/robot.png`" width="55">
      {{$t('common[2]')}}
    </a> -->
    <van-dialog class="SiteDialog" v-model="showAuto" :title="$t('common[3]')" close-on-click-overlay :confirm-button-text="$t('common[4]')" :before-close="confirmAuto">
      <van-divider>{{$t('common[5]')}} {{StatisticalData.today_s_o_num}}</van-divider>
      <van-field :label="$t('common[6]')" label-width="auto" center class="AutoNum">
        <template #input>
          <van-stepper v-model="autoNum" min="0" :max="StatisticalData.today_s_o_num" disable-input button-size="36" input-width="50" :disabled="StatisticalData.today_s_o_num?false:true" />
        </template>
      </van-field>
    </van-dialog>
    <van-dialog v-model="showPush" class="push-dialog" theme="round-button" @confirm="confirmPush" @closed="closedPush">
      <template #title>
        <img :src="`./static/images/${Theme}/logo.png`" height="40">
      </template>
      <h1 v-if="pushMsg.title">{{pushMsg.title}}</h1>
      <h4 v-if="pushMsg.msg">{{pushMsg.msg}}</h4>
      <div v-if="pushMsg.money" class="money">
        {{pushMsg.money}}
      </div>
      <div v-if="pushMsg.convert" class="convert">
        {{pushMsg.convert}}
      </div>
    </van-dialog>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide () {
    return {
      reloadHtml: this.reloadHtml
    }
  },
  components: {

  },
  props: [],
	data() {
    return {
      percentNum: 0,
      showEntrance: false,
      networkState: 1,
      isQuit: false,
      isView: true,
      isRouterAlive: true,
      showMiliao: false,
      minMiliao: false,
      translateX: '0',
      translateY: '-150',
      isCancel: false,
      showService: true,
      showRobot: false,
      showAuto: false,
      autoNum: 0,
      socketWeb: null,
      lockReconnect: false,
      pushList: [],
      pushMsg: '',
      showPush: false,
    }
  },
  computed: {

  },
  watch: {
    '$route'(to, from) {
      this.isQuit = false;
      localStorage['BackUrl'] = to.name
      // if(this.$store.state.InitData.setting.is_robot==1){
      //   if(to.name!='login'&&to.name!='register'&&to.name!='language'&&to.name!='line'){
      //     this.showRobot = true
      //   }else{
      //     this.showRobot = false
      //   }
      // }
      if((from.name=='login'||from.name=='register')&&localStorage['Token']){
        this.creationPush()
      }
      if(to.name=='login'||to.name=='register'){
        this.socketWeb&&this.socketWeb.close()
        clearTimeout(this.reconnectTimer)
      }
      if(to.meta.active!='activity'){
        localStorage.removeItem('ActivityTab')
      }
    },
  },
	created() {
    this.creationPush()
  },
  mounted() {
    $('body').on('click','.openDialog',(event)=>{
      const title = event.currentTarget.title
      if(title){
        this.$Dialog.Alert(title)
      }else{
        this.$Dialog.Alert(this.$t('dialog[7]'))
      }
    });
    $('body').on('click','.routerLink',(event)=>{
      const url = $(event.currentTarget).data('url')
      if(url){
        this.$router.push(url)
      }else{
        return false
      }
    });
    $('body').on('click','#CloseAlert',()=>{
      this.$dialog.close();
    });
    /*APP初始化启动*/
    document.addEventListener("plusready", () => {
      document.addEventListener("pause", ()=>{
        this.isView = false
        console.log('后台')
      }, false);
      document.addEventListener("resume", ()=>{
        this.isView = true
        console.log('前台')
      }, false);
      document.addEventListener("newintent", ()=>{
        var args = plus.runtime.arguments;
        if(args){
          this.$router.push(args)
        }
        console.log(args)
      }, false);
      this.winH = document.body.clientHeight;
      plus.runtime.getProperty(plus.runtime.appid, wgtinfo => {
        localStorage["AppVersion"] = wgtinfo.version;
        checkUpdate(wgtinfo.version);
      });
      // document.addEventListener("netchange",() => {
      //   var nt = plus.networkinfo.getCurrentType();
      //   switch (nt) {
      //     case plus.networkinfo.CONNECTION_ETHERNET:
      //     case plus.networkinfo.CONNECTION_WIFI:
      //     case plus.networkinfo.CONNECTION_CELL2G:
      //     case plus.networkinfo.CONNECTION_CELL3G:
      //     case plus.networkinfo.CONNECTION_CELL4G:
      //       console.log("有网络");
      //       this.networkState = 1;
      //       break;
      //     case plus.networkinfo.CONNECTION_UNKNOW:
      //     case plus.networkinfo.CONNECTION_NONE:
      //       console.log("无网络");
      //       this.networkState = 0;
      //       break;
      //     default:
      //       console.log("未知网络");
      //       this.networkState = 2;
      //       break;
      //   }
      // },false);
      if (plus.os.name == "iOS") {
        iosBack();
      }
      plus.key.addEventListener("backbutton", () => {
        appBack();
      });
    });
    let retry = 0;
    var checkUrl = UpdateUrl[0];
    const checkUpdate = (wgtVer) => {
      $.ajax({
        url: checkUrl,
        dataType: "json",
        data: {
          version: wgtVer
        },
        timeout: 2000,
        success: data => {
          if(data.code==0){
            this.$Dialog.Confirm(data.code_dec,()=>{
              downWgt(data.url);
            })
          }
        },
        error: (xhr, type, errorThrown) => {
          retry+=1
          if(retry<2){
            checkUpdate(wgtVer)
          }else{
            if (checkUrl != UpdateUrl[1]) {
              retry = 0;
              checkUrl = UpdateUrl[1];
              checkUpdate(wgtVer)
            } else {
              console.log("网络错误，无法更新");
            }
          }
        }
      });
    };
    const downWgt = (wgtUrl) => {
      const downToast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('appMsg[0]')
      });
      var task = plus.downloader.createDownload(wgtUrl,{filename: "_doc/update/"},(d, status) => {
          if (status == 200) {
            console.log("下载更新成功：" + d.filename);
            this.$toast.clear();
            this.$Dialog.Confirm(this.$t('appMsg[1]'),()=>{
              installWgt(d.filename);
            })
          } else {
            console.log("下载更新失败");
            this.$toast.fail(this.$t('appMsg[2]'));
          }
        }
      );

      task.addEventListener("statechanged", (download, status) => {
        switch (download.state) {
          case 2:
            downToast.message = this.$t('appMsg[3]',{num: 0});
          case 3:
            this.percentNum = parseInt(
              (download.downloadedSize / download.totalSize) * 100
            );
            downToast.message = this.$t('appMsg[3]',{num: this.percentNum});
            break;
          case 4:
            break;
        }
      });
      task.start();
    };
    const installWgt = path => {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('appMsg[4]'),
      });
      plus.runtime.install( path, {}, () => {
        console.log("安装更新文件成功");
        localStorage.clear();
        this.$toast.success({
          forbidClick: true,
          message: this.$t('appMsg[5]'),
          onClose() {
            plus.runtime.restart();
          }
        });
      }, e => {
        console.log("安装更新文件失败[" + e.code + "]：" + e.message);
        this.$toast.success(this.$t('appMsg[6]'));
      });
    };
    const iosBack = () => {
      var startX = 0;
      var endX = 0;
      document.addEventListener(
        "touchstart",
        event => {
          if (event.targetTouches.length == 1) {
            var touch = event.targetTouches[0];
            startX = touch.screenX;
          }
        },
        { passive: false }
      );
      document.addEventListener(
        "touchend",
        event => {
          if (event.changedTouches.length == 1) {
            var touch = event.changedTouches[0];
            endX = touch.screenX;
            if (startX <= 20 && endX >= 80) {
              appBack();
            }
          }
        },
        { passive: false }
      );
    };
    const appBack = () => {
      if (
        this.$route.name == "home") {
        if (this.isQuit) {
          plus.runtime.quit();
          this.isReconnect = false
          this.Socket&&this.Socket.close();
        } else {
          this.$toast({
            message: this.$t('appMsg[7]'),
            position: "bottom"
          });
          this.isQuit = true;
        }
      } else {
        if ($(".van-nav-bar__left").length) {
          $(".van-nav-bar__left").click();
        } else {
          this.$router.go(-1);
        }
      }
    };
    // 拖动
    this.dragElement("Service")
  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    closedPush() {
      if(this.pushList.length){
        this.pushMsg = this.pushList[0]
        this.showPush = true
      }
    },
    confirmPush() {
      this.showPush = false
      this.pushList.shift()
      
    },
    creationPush() {
      if(WsUrl&&!Boolean(localStorage['PushState'])){
        this.$Model.GetPushMsg(data=>{
          if(data.code==1){
            this.pushList = data.list
            this.closedPush()
            this.creationWebSocket()
          }
        })
      }
    },
    creationWebSocket() {
      try {
        if ("WebSocket" in window) {
          this.socketWeb = new WebSocket(WsUrl)
        } else if ("MozWebSocket" in window) {
          this.socketWeb = new MozWebSocket(WsUrl);
        } else {
          this.$Dialog.Alert(
            "Your browser does not support the WebSocket protocol"
          );
        }
        this.socketWeb.onclose = evnt => {
          console.log("连接关闭");
          if(this.$route.name!='login'||this.$route.name!='register'){
            this.reconnectWebSocket()
          }
        };
        this.socketWeb.onerror = () => {
          console.log("连接错误");
          if(this.$route.name!='login'||this.$route.name!='register'){
            this.reconnectWebSocket()
          }
        };
        this.socketWeb.onopen = evnt => {
          console.log("连接成功");
          this.socketSend({"push": localStorage['UserId']})
        };
        this.socketWeb.onmessage = evnt => {
          var data = JSON.parse(evnt.data);
          console.log(data)
          if(data.ping){
            this.socketSend({"pong": data.ping})
          }
          if(data.push){
            this.pushList.unshift(data)
            this.closedPush()
          }
        };
      } catch (e) {
        this.reconnectWebSocket();
      }
    },
    reconnectWebSocket() {
      if (this.lockReconnect) {
        clearTimeout(this.reconnectTimer)
        return
      }
      this.lockReconnect = true
      this.reconnectTimer = setTimeout(() => {
        this.creationWebSocket()
        this.lockReconnect = false
      }, 2000)
    },
    socketSend(data) {
      const BlobData = new Blob([JSON.stringify(data)])
      this.socketWeb.send(BlobData)
    },
    confirmAuto(action,done) {
      if (action === 'confirm') {
        if(!this.autoNum){
          this.$Dialog.Toast(this.$t('common[8]'))
          done(false)
          return
        }
        if(this.StatisticalData.today_s_o_num){
          done()
          this.$Model.Robot(this.autoNum,data=>{
            if(data.code==1){
              this.autoNum = this.StatisticalData.today_s_o_num
            }
            if(data.code==2){
              this.$Dialog.Alert(data.code_dec,()=>{
                this.$router.push('/vip')
              })
            }
          })
        }else{
          done()
          this.$Dialog.Alert(this.$t('common[5]')+" "+this.StatisticalData.today_s_o_num)
        }
      } else {
        done()
      }
    },
    openRobot() {
      this.$Model.GetStatisticsInfo(data=>{
        if(data.code==1){
          this.autoNum = data.info.today_s_o_num
          this.showAuto = true
        }
      })
    },
    reloadHtml () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    dragElement(id) {
      var obj = document.getElementById(id);
      var drag = false;
      var screenHeight = document.documentElement.clientHeight;
      var screenWidth = document.documentElement.clientWidth;
      var pageX = screenWidth;
      obj.addEventListener('touchstart',(ev)=>{
        drag = true;
        if (obj.setCapture) {
          obj.setCapture();
        }
        $(obj).removeClass('move')
      });
      obj.addEventListener('touchmove',(ev)=>{
        $(obj).removeClass('move')
        ev.preventDefault();
        ev = ev.touches?ev.touches[0]:event;
        if(drag){
          if(ev.pageY<obj.clientHeight/2){
            obj.style.bottom = screenHeight-obj.clientHeight-5+'px';
          }else if(ev.pageY>screenHeight-5-obj.clientHeight/2){
            obj.style.bottom = '5px';
          }else{
            obj.style.bottom = screenHeight-ev.pageY-obj.clientHeight/2+'px';
          }
          if(ev.pageX<obj.clientWidth/2){
            obj.style.right = screenWidth-obj.clientWidth+'px';
          }else if(ev.pageX>screenWidth-obj.clientWidth/2){
            obj.style.right = 0;
          }else{
            obj.style.right = screenWidth-ev.pageX-obj.clientWidth/2+'px';
          }
          pageX = ev.pageX
        }
      });
      obj.addEventListener('touchend',(ev)=>{
        drag = false;
        $(obj).addClass('move')
        if(pageX>screenWidth/2){
          obj.style.right = '5px';
        }else{
          obj.style.right = screenWidth-obj.clientWidth-5+'px';
        }
      })
    },
    openService(url,id,urltype){
      const urlArr = url.split(",")
      const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      this.iosUrl = urlArr[this.getRandom(urlArr.length)]
      let winRef = null
      
      if(urltype=='w'){
        if(isIOS){
          winRef = window.open(" ","_blank");
        }
        this.$Model.GetOnline(data=>{
          if(data.in_online==1){
            if (window.plus) {
              plus.runtime.openURL(this.iosUrl)
            } else {
              if(isIOS){
                winRef.location = this.iosUrl
              }else{
                window.open(this.iosUrl)
              }
            }
          }else{
            winRef.close()
          }
        },{id: id})
      }else{
        this.$router.push(url)
      }
    },
    getRandom(len) {
      return Math.floor(Math.random()*(len) + 0);
    },
  }
}
</script>
<style scoped>
#Robot{
  position: absolute;
  bottom: 140px;
  right: 0;
  z-index: 99;
  color: #999;
  line-height: 1;
  text-align: center;
  font-size: 12px;
}
#Robot img{
  display: block;
  margin: 0 auto;
}
#Robot.move{
  transition: all 0.3s;
}
.AutoNum{
  justify-content: center;
  padding: 0 15px 15px;
}
.AutoNum>>>.van-field__value{
  flex: none;
  margin-left: 10px;
}
.push-dialog{
  border-radius: 10px;
  text-align: center;
}
.push-dialog>>>.van-dialog__header{
  padding-left: 24px;
  padding-right: 24px;
}
.push-dialog>>>.van-dialog__header img{
  margin: 0 auto;
}
.push-dialog>>>.van-dialog__content{
  padding: 24px;
  line-height: 1;
  font-size: 16px;
  font-weight: 600;
}
.push-dialog>>>.van-dialog__content h1{
  color: #3431b3;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 16px;
}
.push-dialog>>>.van-dialog__content h4{
  font-weight: 600;
}
.push-dialog>>>.van-dialog__content .money{
  margin-top: 20px;
}
.push-dialog>>>.van-dialog__content .convert{
  font-size: 22px;
  margin-top: 10px;
}
.push-dialog>>>.van-button{
  height: 44px;
  font-size: 16px;
  background: var(--button-main);
}
</style>